exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-center[data-v-23704a72]{background-position:50%;background-repeat:no-repeat;background-size:cover}", ""]);

// exports
